import TextTooltip from "../general/TextTooltip";

export default function AvailableSeasonTooltip(props) {
  const { availableSeason } = props;

  return (
    <div className="group">
      <div className="w-[40px] h-[40px] flex justify-center items-center bg-olaf-brown-500 rounded-full border-2 border-white">
        <img
          src="/assets/icon/calendar.svg"
          alt="Calendar icon"
          width="20"
          height="20"
        />
      </div>
      <TextTooltip>
        <p className="text-[10px] font-semibold leading-[14px]">
          Seizoensgebonden product
        </p>
        <p className="text-[9px] leading-[12px] !mt-2.5">
          Beschikbaar in periode:
        </p>
        <p className="lowercase text-xs font-semibold leading-[16px] !mt-0">
          <strong>
            {availableSeason.month_from} tot {availableSeason.month_till}
          </strong>
        </p>
      </TextTooltip>
    </div>
  );
}
